import React from "react";

const SvgLeo = (props) => {
  return (
    <svg
      viewBox="0 0 34.68 41.88"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M33.62 30.05a1.506 1.506 0 00-2-.72c-.75.35-1.07 1.25-.72 2 .02.03 1.6 3.53.25 5.64-.8 1.26-2.61 1.9-5.38 1.9-1.82 0-3.47-1.13-4.31-2.95-1.16-2.49-.52-5.55 1.7-8.18.7-.83 1.62-1.62 2.59-2.47 3.25-2.8 7.29-6.3 7.29-14.23C33.05 7.22 30.62 0 21.44 0c-5.47 0-9.41 1.64-11.71 4.86C6.77 9 7.44 14.58 8.09 17.52h-.04C3.61 17.52 0 21.13 0 25.57c0 4.44 3.61 8.05 8.05 8.05S16.1 30 16.1 25.57c0-3.25-1.94-6.06-4.73-7.32-.41-1.37-2.06-7.63.8-11.64C13.88 4.21 16.99 3 21.44 3c6.8 0 8.61 5.05 8.61 8.04 0 6.57-3.18 9.31-6.25 11.96-1.07.92-2.08 1.79-2.93 2.8-2.99 3.55-3.79 7.8-2.13 11.38 1.34 2.89 4.04 4.69 7.03 4.69 3.86 0 6.52-1.11 7.91-3.3 2.24-3.52.03-8.31-.06-8.52zM13.1 25.57c0 2.78-2.27 5.05-5.05 5.05S3 28.35 3 25.57s2.27-5.05 5.05-5.05 5.05 2.26 5.05 5.05z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgLeo;
